import markerImg from '../../framework/images/marker.png';

export const clusterMarkerIcons = () => [
  {
    textSize: 17,
    textColor: '#fff',
    className: 'cluster1',
    height: 30,
    width: 30,
  },
  {
    textSize: 17,
    textColor: '#fff',
    className: 'cluster2',
    height: 36,
    width: 36,
  },
  {
    textSize: 17,
    textColor: '#fff',
    className: 'cluster3',
    height: 44,
    width: 44,
  },
  {
    textSize: 17,
    textColor: '#fff',
    className: 'cluster4',
    height: 51,
    width: 51,
  },
  {
    textSize: 17,
    textColor: '#fff',
    className: 'cluster5',
    height: 61,
    width: 61,
  },
];

export const markerOptions = () => {
  return {
    icon: {
      url: markerImg,
      width: 22,
      height: 40,
    },
  };
};

export const mapOption = (settings = {}) => {
  return {
    disableDefaultUI: true,
    clickableIcons: false,
    ...settings,
  };
};
